export const normalizeNumbersList = (arr: Array<string | number> = []): string[] => {
    const splitRegex = /[,\s|;]+/;
    const out: string[] = [];

    for (const item of arr) {
        if (item == null) {
            continue;
        }

        const s = String(item).trim();
        if (!s) {
            continue;
        }

        // If backend sent a JSON array as string, e.g. '["1001","1002"]' or '[1001,1002]'
        if (s.startsWith("[") && s.endsWith("]")) {
            try {
                const parsed = JSON.parse(s);
                if (Array.isArray(parsed)) {
                    for (const v of parsed) {
                        const str = String(v).trim();
                        if (str) {
                            out.push(str);
                        }
                    }
                    continue; // handled this item fully
                }
            } catch {
                // ignore JSON parse errors and fall through to normal split
            }
        }

        // Normal case: "1002440937,1002440949"
        const parts = s.split(splitRegex);
        for (const p of parts) {
            const t = p.trim();
            if (t) {
                out.push(t);
            }
        }
    }

    // Deduplicate while preserving order
    const seen = new Set<string>();
    const unique: string[] = [];
    for (const v of out) {
        if (!seen.has(v)) {
            seen.add(v);
            unique.push(v);
        }
    }
    return unique;
};

export type DecimalFormatOptions = {
    locale?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
};

export function formatDecimal(
    value: number | string,
    { locale = "en-US", minimumFractionDigits = 2, maximumFractionDigits = 2 }: DecimalFormatOptions = {},
): string {
    const num = typeof value === "string" ? Number(value) : value;
    if (!Number.isFinite(num)) {
        return "";
    }
    return new Intl.NumberFormat(locale, {
        style: "decimal",
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(num);
}
